import { Inject, Injectable, Type } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch, optimisticUpdate } from '@nrwl/angular';

import * as NotificationsActions from './notifications.actions';
import { map, mapTo, pluck, catchError, mergeMap } from 'rxjs/operators';
import { NotificationsActionTypes } from './notifications.actions';
import { of, EMPTY } from 'rxjs';
import { ROOT_SERVICE } from '../../tokens';
import { NotificationServiceBase } from '../../notification-service.base';

@Injectable()
export class NotificationsEffects {

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationsActions.load),
      fetch({
        run: () => {
         return this.service.loadNotifications().pipe(
           map((notifications) => NotificationsActions.loadNotificationsSuccess({
             notifications
           }))
         )
        },
        onError: (action, error) => {
          console.error('Error', error);
          return NotificationsActions.loadNotificationsFailure({ error });
        }
      })
    )
  );

  markAsRead$ =  createEffect(()=>
  this.actions$.pipe(
    ofType(NotificationsActions.markAsRead),
    optimisticUpdate({
      run: ({notification}) => {
        return this.service.markAsRead(notification.id).pipe(
          mapTo({
            type: NotificationsActionTypes.MarkAsReadSuccess
          }),
          catchError((err) => {
            console.log(err)
            return EMPTY})
        )
      },
      undoAction: ({notification}) => NotificationsActions.markAsReadUndo({id: notification.id})
    })
  ))

  // markAsUnread$ =  createEffect(()=>
  // this.actions$.pipe(
  //   ofType(NotificationsActions.markAsRead),
  //   optimisticUpdate({
  //     run: ({notification}) => {
  //       return this.service.markAsUnread(notification.id).pipe(
  //         mapTo({
  //           type: NotificationsActionTypes.MarkAsUnreadSuccess
  //         })
  //       )
  //     },
  //     undoAction: ({notification}) => NotificationsActions.markAsUnreadUndo({id: notification.id})
  //   })
  // ))

  deleteOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotificationsActions.deleteOne),
      pluck('id'),
      mergeMap((id) => this.service.deleteOne(id).pipe(
        mapTo( NotificationsActions.deleteOneSuccess({id})),
        catchError((error) => of(NotificationsActions.deleteOneFailure({error})))
      ))
    )
  )

  downloadReport$ = createEffect(() =>
        this.actions$.pipe(
          ofType(NotificationsActions.downloadReport),
          mergeMap(({reportId, filename}) => this.service.downloadReport(reportId, filename))
        )
  , {
   dispatch: false
  })

  constructor(private readonly actions$: Actions, @Inject(ROOT_SERVICE) private service: NotificationServiceBase) {
  }
}
